// El video pesa cientos de KB y vive debajo del pliegue: con autoplay + preload el
// navegador lo descarga en la carga inicial aunque nadie lo vea. Se difiere hasta que
// se acerca al viewport.
//
// ponytail: comprobación de rectángulo en un listener de scroll pasivo, no
// IntersectionObserver. IO depende del ciclo de renderizado y no entrega callbacks en
// pestañas en segundo plano; esto no puede quedarse colgado sin cargar nunca.
class LanzoVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.comprobar = () => {
      const r = this.getBoundingClientRect();
      const alto = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < alto + 400 && r.bottom > -400) this.arrancar();
    };

    addEventListener('scroll', this.comprobar, { passive: true });
    addEventListener('resize', this.comprobar, { passive: true });
    this.comprobar();
  }

  disconnectedCallback() {
    this.soltar();
  }

  soltar() {
    if (!this.comprobar) return;
    removeEventListener('scroll', this.comprobar);
    removeEventListener('resize', this.comprobar);
    this.comprobar = null;
  }

  arrancar() {
    if (this.arrancado) return;
    this.arrancado = true;
    this.soltar();

    const video = this.video;
    if (video.dataset.src && !video.querySelector('source')) {
      const source = document.createElement('source');
      source.src = video.dataset.src;
      source.type = video.dataset.type || 'video/mp4';
      video.appendChild(source);
    }
    video.preload = 'metadata';
    // el marco conserva su proporción reservada a propósito: cambiarla al conocer las
    // dimensiones reales del video sería un layout shift garantizado
    video.load();
    if (video.autoplay) {
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    }
  }
}

customElements.define('lanzo-video', LanzoVideo);
